// Importar los pages
// Este archivo de rutas, debe ser dinámico e incremental

import Layout from "../../layouts/Layout";
import Home from "../../pages/home/Home";
import Contact from "../../pages/contact/Contact";
import Soluciones from "../../pages/soluciones/Soluciones";
import DetalleSolucion from "../../pages/detalle-solucion/DetalleSolucion";
import DetalleIndustria from "../../pages/detalle-industria/DetalleIndustria";
import Podcast from "../../pages/podcast/Podcast";
import Articulos from "../../pages/articulos/Articulos";
import DetalleArticulo from "../../pages/detalle-articulo/DetalleArticulo";
import DetallePodcast from "../../pages/detalle-podcast/DetallePodcast";
import CasosExito from "../../pages/casos-exito/CasosExito";
import DetalleCasoExito from "../../pages/detalle-caso-exito/DetalleCasoExito";

const title: string = 'Soluciones Energéticas de Gasco';
const breadTitle: string = '';

const routes = [
  {
    path: '/',
    title: 'Soluciones Energéticas de Gasco para Empresas',
    breadTitle: breadTitle,
    layout: Layout,
    component: Home
  },
  {
    path: '/contacto',
    title: 'Atención al Cliente | Gasco Soluciones Energéticas',
    breadTitle: breadTitle,
    layout: Layout,
    component: Contact
  },
  {
    path: '/soluciones',
    title: 'Soluciones para las Industrias | Gasco Soluciones Energéticas',
    breadTitle: breadTitle,
    layout: Layout,
    component: Soluciones
  },
  {
    path: '/soluciones/:slug',
    title: '{solucion} | Gasco Soluciones Energéticas',
    breadTitle: breadTitle,
    layout: Layout,
    component: DetalleSolucion
  },
  {
    path: '/industrias/:slug',
    title: '{industria} | Gasco Soluciones Energéticas',
    breadTitle: breadTitle,
    layout: Layout,
    component: DetalleIndustria
  },
  {
    path: '/casos-de-exito',
    title: 'Casos de Éxito | Gasco Soluciones Energéticas',
    breadTitle: breadTitle,
    layout: Layout,
    component: CasosExito
  },
  {
    path: '/casos-de-exito/:slug',
    title: '{casoExito} | Gasco Soluciones Energéticas',
    breadTitle: breadTitle,
    layout: Layout,
    component: DetalleCasoExito
  },
  {
    path: '/podcast',
    title: 'Podcast Energía que transforma | Gasco Soluciones Energéticas',
    breadTitle: breadTitle,
    layout: Layout,
    component: Podcast
  },
  {
    path: '/podcast/:slug',
    title: '{podcast} - Gasco Soluciones Energéticas para Empresas',
    breadTitle: breadTitle,
    layout: Layout,
    component: DetallePodcast
  },
  {
    path: '/articulos',
    title: 'Blog de Soluciones Energéticas Gasco',
    breadTitle: breadTitle,
    layout: Layout,
    component: Articulos
  },
  {
    path: '/articulo/:slug',
    title: '{articulo} - Gasco Soluciones Energéticas para Empresas',
    breadTitle: breadTitle,
    layout: Layout,
    component: DetalleArticulo
  }
];

export default routes;